import { render, staticRenderFns } from "./ymsIndex.vue?vue&type=template&id=4aecc7d7&scoped=true"
import script from "./ymsIndex.vue?vue&type=script&lang=js"
export * from "./ymsIndex.vue?vue&type=script&lang=js"
import style0 from "./ymsIndex.vue?vue&type=style&index=0&id=4aecc7d7&prod&lang=css"
import style1 from "./ymsIndex.vue?vue&type=style&index=1&id=4aecc7d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aecc7d7",
  null
  
)

export default component.exports